export const testimonials = [
  {
    id: 1,
    key: 'carlos',
    avatar: 'CM',
    rating: 5,
  },
  {
    id: 2,
    key: 'ana',
    avatar: 'AP',
    rating: 5,
  },
  {
    id: 3,
    key: 'pedro',
    avatar: 'PS',
    rating: 4,
  },
];